export default "__VITE_ASSET__CR8JADDo__"